// extracted by mini-css-extract-plugin
var _1 = "RootErrorBoundaryFallback-module__actions--HAjP3";
var _2 = "RootErrorBoundaryFallback-module__animateUploadProgressBarWidth--GqxBT";
var _3 = "RootErrorBoundaryFallback-module__animatedBackground--w1JDr";
var _4 = "RootErrorBoundaryFallback-module__background--mQ09T";
var _5 = "RootErrorBoundaryFallback-module__button--GmjL8";
var _6 = "RootErrorBoundaryFallback-module__container--fmSe_";
var _7 = "RootErrorBoundaryFallback-module__content--Q7jAI";
var _8 = "RootErrorBoundaryFallback-module__description--sGFtv";
var _9 = "RootErrorBoundaryFallback-module__logo--RrwhW";
var _a = "RootErrorBoundaryFallback-module__primary--w_hrf";
export { _1 as "actions", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "background", _5 as "button", _6 as "container", _7 as "content", _8 as "description", _9 as "logo", _a as "primary" }
